import React, { useState } from 'react';
import axios from 'axios';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Loader2, AlertCircle, ShieldCheck } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const errMsg = (e, d) => (typeof e.response?.data?.detail === 'string' ? e.response.data.detail : d);

// Second login step: 6-digit code e-mailed to editors and admins
export const LoginCodeStep = ({ challenge, setChallenge, onDone, onBack }) => {
  const [code, setCode] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [info, setInfo] = useState('');
  const verify = async (e) => {
    e.preventDefault();
    if (code.length !== 6) { setError('Digite os 6 números do código.'); return; }
    setBusy(true); setError('');
    try {
      const { data } = await axios.post(`${API}/auth/login/verify`, { challenge_id: challenge.challenge_id, code });
      onDone(data);
    } catch (err) { setError(errMsg(err, 'Não foi possível verificar o código.')); setCode(''); }
    setBusy(false);
  };
  const resend = async () => {
    setError(''); setInfo('');
    try {
      const { data } = await axios.post(`${API}/auth/login/resend`, { challenge_id: challenge.challenge_id });
      setChallenge(data); setInfo('Enviamos um novo código.');
    } catch (err) { setError(errMsg(err, 'Não foi possível reenviar o código.')); }
  };
  return (
    <form onSubmit={verify} className="login-form" data-testid="login-code-step">
      <div style={{ display: 'flex', gap: 10, alignItems: 'flex-start', marginBottom: '0.5rem' }}>
        <ShieldCheck className="w-5 h-5" style={{ color: 'var(--lv-accent, #46B934)', flexShrink: 0, marginTop: 2 }} />
        <p style={{ fontSize: '0.9rem', margin: 0 }} data-testid="login-code-hint">
          Enviamos um código de 6 dígitos para <strong>{challenge.email_hint}</strong>. Ele vale por 10 minutos.
        </p>
      </div>
      <div className="form-field">
        <Label htmlFor="login-code">Código de verificação</Label>
        <Input id="login-code" value={code} autoFocus inputMode="numeric" autoComplete="one-time-code" maxLength={6} placeholder="000000"
          onChange={(e) => { setCode(e.target.value.replace(/\D/g, '').slice(0, 6)); setError(''); }}
          style={{ letterSpacing: '0.5em', fontSize: '1.25rem', textAlign: 'center' }} data-testid="login-code-input" />
      </div>
      {error && <div className="login-error" data-testid="login-code-error"><AlertCircle className="w-4 h-4" /><span>{error}</span></div>}
      {info && <p style={{ fontSize: '0.85rem', color: 'var(--lv-accent, #46B934)' }} data-testid="login-code-info">{info}</p>}
      <Button type="submit" className="btn-primary-custom w-full" disabled={busy} data-testid="login-code-submit">
        {busy ? <><Loader2 className="w-4 h-4 animate-spin mr-2" /> Verificando...</> : 'Confirmar e entrar'}
      </Button>
      <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.85rem', marginTop: '0.5rem' }}>
        <button type="button" onClick={onBack} data-testid="login-code-back" style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'inherit', opacity: 0.8 }}>Voltar</button>
        <button type="button" onClick={resend} data-testid="login-code-resend" style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--lv-accent, #46B934)', fontWeight: 600 }}>Reenviar código</button>
      </div>
    </form>
  );
};
